// extracted by mini-css-extract-plugin
export default {"draggable":"Pupil_draggable__t7c7q","dragging":"Pupil_dragging__UnDiu","droppable":"Pupil_droppable__OoHJZ","customDragged":"Pupil_customDragged__SpLZ9","bwt":"Pupil_bwt__qAhMD"};